/** Logic to support different base app domains, in particular thourgh google proxy  */
import {isOnServer} from '@gfiber/typesmith';

export const googleProxyPrefix = process.env.NEXT_PUBLIC_GOOGLE_PROXY_PREFIX;

/**
 * To determin is the request come from google.com or gfiber.com.
 *
 * @returns True of false based on the request come from
 */
export const isRequestedFromGoogleProxy = () => {
  if (isOnServer()) {
    // code probably run on server side during build or rendering phase
    return false;
  }

  // code run on client
  const requestHostname = window.location.hostname || '';
  return requestHostname.endsWith('google.com');
};

export const gfiberDomain = process.env.NEXT_PUBLIC_GFIBER_DOMAIN;
export const overrideCiamEnabled =
  process.env.NEXT_PUBLIC_OVERRIDE_CIAM_ENABLED;

/**
 * Determine whether CIAM authentication should be used
 * By default enabled under gfiber.com domain, but can be overrided by NEXT_PUBLIC_OVERRIDE_CIAM_ENABLED environment variable
 * */
export const isCiamEnabled = (): boolean => {
  if (overrideCiamEnabled === 'true') {
    return true;
  }

  if (isOnServer() || overrideCiamEnabled === 'false') {
    // code probably run on server side during build or rendering phase
    return false;
  }

  // code run on client
  const hostname = window.location.hostname || '';
  return hostname.endsWith(gfiberDomain || '');
};
